module.exports = __webpack_public_path__ + "/login_ui/img/pl-541c79ad6a95f0736f80130e389d6997.svg";